import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PersonIcon from '@mui/icons-material/Person';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RefreshIcon from '@mui/icons-material/Refresh';
import PercentIcon from '@mui/icons-material/Percent';
import BoltIcon from '@mui/icons-material/Bolt';
import { CacIcon, ChureIcon, ConverstionIcon, FemaleIcon, PaidIcon, RetentionIcon } from '../../../icons';
import { useSelector } from 'react-redux';
import { fetchFinancialMetrics } from '../../../api/nystats';

const list = [
    { id: 1, title: 'CAC (Cost Per Paying User)', value: '0', icon: <CacIcon fontSize="small" /> },
    { id: 2, title: 'Paid Conversion (Male)', value: '0', icon: <PaidIcon fontSize="small" /> },
    { id: 3, title: 'Female Signup Cost (CPL)', value: '0', icon: <FemaleIcon fontSize="small" /> },
    { id: 4, title: 'Retention/Renewal', value: '0%', icon: <RetentionIcon fontSize="small" /> },
    { id: 5, title: 'Churn Rate', value: '0%', icon: <ChureIcon fontSize="small" /> },
    { id: 6, title: 'Conversion Rate', value: '0%', icon: <ConverstionIcon fontSize="small" /> },
];

// Default export: Financial metrics cards (single-line, responsive)
export default function FinancialMetricsCards() {
  	const { filter } = useSelector((state) => state);
	  const [metrics, setMetrics] = useState(list);
	  const [isLoading, setIsLoading] = useState(false);

	const fetchData = async () => {
		try {
			setIsLoading(true);
			const data = await fetchFinancialMetrics(filter);
			setMetrics([
    { id: 1, title: 'CAC (Cost Per Paying User)', value: data?.CAC ?? 0, icon: <CacIcon fontSize="small" /> },
    { id: 2, title: 'Paid Conversion (Male)', value: `${data?.malePaidConversion ?? 0}%`, icon: <PaidIcon fontSize="small" /> },
    { id: 3, title: 'Female Signup Cost (CPL)', value: data?.femaleCPL ?? 0, icon: <FemaleIcon fontSize="small" /> },
    { id: 4, title: 'Retention/Renewal', value: `${data?.retention ?? 0}%`, icon: <RetentionIcon fontSize="small" /> },
    { id: 5, title: 'Churn Rate', value: `${data?.churn ?? 0}%`, icon: <ChureIcon fontSize="small" /> },
    { id: 6, title: 'Conversion Rate', value: `${data?.conversion ?? 0}%`, icon: <ConverstionIcon fontSize="small" /> },
]);
		} catch (err) {
			console.error("Error while loading New York financial data", err);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [filter]);

  return (
    <Box p={2} sx={{ boxShadow: 'none', border: '1px solid #e6e6e6', borderRadius: '20px', p: 2 }}>
		<Typography sx={{fontSize:'20px', color:'#3C4043', borderLeft:'3px solid #FBBF24', paddingLeft:'10px', mb:3, fontWeight:'500', }}>
			Financial Metrics
		</Typography>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          px: 0,
          py: 0,
          // keep cards on a single line and allow horizontal scroll on small screens 
        }}
      >
        {isLoading ? 
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> :
        metrics?.map((m) => (
          <Card
            key={m.id}
            elevation={0}
            sx={{ 
              backgroundColor: '#F5F3F0',
              p: '16px', // 16px padding as requested
              boxShadow: 'none',
              borderRadius: 2,  width:'100%'
            }}
          >
            <CardContent sx={{ p: 0, width: '100%', '&.MuiCardContent-root:last-child':{paddingBottom:'7px'} }}>
              {/* Icon (top) */}
              <Box sx={{ mb: 1 }}>{m.icon}</Box>

              {/* Label */}
              <Typography
                variant="body2"
                sx={{
                  color: '#6B6B6B',
                  fontSize: '12px',
                  lineHeight: 1.2,
                  mb: 0.5,
                }}
              >
                {m.title}
              </Typography>

              {/* Value / Price */}
              <Typography
                variant="h6"
                sx={{
                  color: '#0A0A0A',
                  fontSize: '20px',
                  fontWeight: 600,
                  lineHeight: 1.1,
                }}
              >
                {m.value}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
